import defineMessages from "../../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    upload: {
        id: "tasks.barSorting.upload",
    },
    systems: {
        id: "tasks.barSorting.systems",
    },
    bars: {
        id: "tasks.barSorting.bars",
    },
    nonBars: {
        id: "tasks.barSorting.nonBars",
    },
    same: {
        id: "tasks.barSorting.same",
    },
    size: {
        id: "tasks.barSorting.size",
    },
    layout: {
        id: "tasks.barSorting.layout",
    },
    back: {
        id: "general.back",
    },
    next: {
        id: "general.next",
    },
    description: {
        id: "intro.barSorting.2.description",
    },
});

export default messages;
